import { ModelGroup, ModelItemAccessor, ModelValidation, ModelValidationResult } from '@mng/model';
import { GvAngebotDataItemAccessor } from '../gvangebot.model.paths';
import { GvAngebotData } from '../gvangebot.model.types';
import { createGvAngebotModel } from './gvangebot.model';
import { hasGvAngebotAenderungen, hasGvAngebotTarifeAnyWarnings } from './logic/gvtarif-model.logic';
import { AngebotStatus } from '@mng/sales-types';

let gvAngebotModel: ModelGroup;
let gvAngebotModelItemAccessor: ModelItemAccessor;

export function getGvAngebotModel(): ModelGroup {
  if (!gvAngebotModel) {
    gvAngebotModel = createGvAngebotModel();
  }
  return gvAngebotModel;
}

export function getGvAngebotModelItemAccessor(): ModelItemAccessor {
  if (!gvAngebotModelItemAccessor) {
    gvAngebotModelItemAccessor = new ModelItemAccessor(getGvAngebotModel());
  }
  return gvAngebotModelItemAccessor;
}

export const gvAngebotItemAccessor: GvAngebotDataItemAccessor = new GvAngebotDataItemAccessor(
  getGvAngebotModelItemAccessor()
);

export function validateGvAngebot(gvAngebotData: GvAngebotData): ModelValidationResult {
  const validation: ModelValidation = new ModelValidation(getGvAngebotModel());
  return validation.validate(gvAngebotData);
}

export function computeGvAngebotStatus(
  gvAngebotData: GvAngebotData,
  modelValidationResult: ModelValidationResult
): AngebotStatus {
  if (modelValidationResult.isValid()) {
    if (gvAngebotData.vertragsAenderung && !hasGvAngebotAenderungen(gvAngebotData)) {
      return AngebotStatus.UNVERAENDERT;
    } else if (hasGvAngebotTarifeAnyWarnings(gvAngebotData.gvPersonenData)) {
      return AngebotStatus.VALID;
    } else {
      return AngebotStatus.BEANTRAGBAR;
    }
  } else {
    return AngebotStatus.INVALID;
  }
}
